import type { AgentDeployment as AgentDeploymentModel } from '@/adapters/catalogv1.g';

export function extractAgentDeployment(model: AgentDeploymentModel) {
  return {
    id: model._metadata?.distinct_id ?? '',
    deploymentRef: model.deployment_ref ?? '',
    agentRef: model.agent_ref ?? '',
    agentVersion: model.agent_version ?? '',
    name: model.name ?? '',
    description: model.description ?? '',
    deploymentType: model.deployment_type ?? '',
    status: model.status ?? '',
    statusReason: model.status_reason ?? '',
    trigger: model.trigger ?? '',
    target: model.target ?? '',
    lastRunAt: model.last_run_at,
    nextRunAt: model.next_run_at,
    tenantId: model._metadata?.tenant_id,
    connectorId: model._metadata?.segment_id,
  };
}

export type CatalogAgentDeployment = ReturnType<typeof extractAgentDeployment>;
